import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Payment.css";

export default function PaymentCancel() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        <div className="payment-icon cancel">X</div>
        <h1>{t("payment.cancelTitle")}</h1>
        <p>{t("payment.cancelMessage")}</p>
        <button className="btn-primary" onClick={() => history.push("/pricing")}>
          {t("nav.pricing")}
        </button>
      </div>
    </div>
  );
}
